<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
    <p>{{ data.content | translate }}</p>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="onDismiss()">{{ "global.dialog.no" | translate }}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{ "global.dialog.yes" | translate }}</button>
</div>